const localStoragePath = 'frescoSourcesStore'
const defaultMinZoom = 0
const defaultMaxZoom = 24

export default {
	defaultMinZoom,
	defaultMaxZoom,
	localStoragePath,
}